// src/features/ads/adsTypes.ts

import { SignupFormData } from "../../pages/SignupForm/SignupForm";
import type { CaptchaPayload } from "../../api/registerApi";
import type { ManualAddressPayload } from "../../api/addressApi";

export interface Ad {
  id?: string;        
  title_i18n: Record<"fr" | "en" | "ar", string>;
  content_i18n: Record<"fr" | "en" | "ar", string>;
  adress_i18n?: Record<"fr" | "en" | "ar", string>;
  price: number;
  top?: number | null;
  rate?: number | null;
  min_nights?: number;
  room_nbr: number;
  nbr_floors?: number | null;
  nbr_bathroom?: number | null;
  nbr_kitchen?: number | null;
  desactiver_commentaire?: boolean;
  descriptionIconListEnabled?: boolean;
  particularites?: string[];
  area: number;
  adress?: string;
  idQuartier?: unknown;
  adressId?: string;
  quartierId?: string;
  manualAddress?: ManualAddressPayload;
  photoFiles?: File[];
  photoPrioritaireIndex?: number;
  type?: string;
  currency: Currency;
  photos?: string[];
}

export interface AdPayload {
  ad: Ad;
  userId?: string;
  user?: Omit<SignupFormData, "status" | "nbr_child"> & Partial<Pick<SignupFormData, "status" | "nbr_child">>;
  captcha?: CaptchaPayload;
}

export const Currenci = {
  EUR: "EUR",
  USD: "USD",
  GBP: "GBP",
  DZD: "DZD"
} as const;

export type Currency = typeof Currenci[keyof typeof Currenci];
